import {Component, Input, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../../../../../modules/modal/modal-ref";
import {Router} from "@angular/router";
import features from "./features.json";
import {GoogleAnalyticsService} from "../../../../../../../shared/services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-demo-progress',
    templateUrl: './apply-pro-upgrade-dialog.component.html',
    styleUrls: ['./apply-pro-upgrade-dialog.component.scss'],
    standalone: false
})
export class ApplyProUpgradeDialogComponent implements OnInit {

  @Input() fromMaximize: boolean;
  public features: string[] = features.features;
  public extraFeatures: string[] = features.extraFeatures;

  constructor(
    private _router: Router,
    private readonly activeModal: DbActiveModal,
    private readonly _googleAnalyticsService: GoogleAnalyticsService
  ) {
  }

  ngOnInit() {
  }

  public redirectToUpgradePage(): void {
    this.sendEvent();
    this._router.navigate(['/upgrade-plan']);
    this.close();
  }

  public close(): void {
    this.activeModal.close();
  }

  public sendEvent(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Upgrade button click',
      eventLabel: this.fromMaximize ? 'Pro Level Upgrade Offer (Maximize your score)' : 'Pro Level Upgrade Offer (Level Select)'
    };

    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
